import { render } from "./Agree.vue?vue&type=template&id=04c0e488&scoped=true"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"

import "./Agree.vue?vue&type=style&index=0&id=04c0e488&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c0e488"]])

export default __exports__